import snakeCase from 'lodash/snakeCase';

import type { Button, Form, ViewOnboardingModule } from '@coursera/event-pulse-types';
import { useTracker } from '@coursera/event-pulse/react';

type OnboardingModuleType = ViewOnboardingModule['onboardingModule']['moduleType'];

const useTrackOnboardingModuleButtonClick = () => {
  const track = useTracker();

  const trackClickOnboardingModuleButton = ({
    buttonName,
    moduleType,
    questionId,
    formEventData,
  }: {
    buttonName: Button['name'];
    moduleType: OnboardingModuleType;
    questionId?: string;
    formEventData?: Form;
  }) => {
    track('click_onboarding_module', {
      onboardingModule: {
        moduleType,
        ...(questionId ? { questionId: snakeCase(questionId) } : {}),
      },
      button: {
        name: buttonName,
      },
      ...(formEventData ? { form: formEventData } : {}),
    });
  };

  return {
    trackClickOnboardingModuleButton,
  };
};

export default useTrackOnboardingModuleButtonClick;
